import { useEffect } from 'react';

/* Mainly used to preload the onboarding and changeboarding images */

// For each image path, a new `Image` object is created and the
// `src` property is set to the image path. This causes the browser
// to download the image and store it in cache.
export const usePreloadImages = (imagePaths: string[]) => {
	useEffect(() => {
		const preloadImages = (paths: string[]) => {
			paths.forEach((path) => {
				const img = new Image();
				img.src = path;
			});
		};

		preloadImages(imagePaths);
	}, [imagePaths]);
};
